const { baseUri, basePath } = require('../../config');

const SUPPLIERS_DASHBOARD = '/suppliers/dashboard';
const BLOG = 'blog';

const createRootPath = path => subPath =>
  `${baseUri}/${path}${subPath ? `/${subPath}` : ''}`;

module.exports.PATHS = {
  home: `${baseUri}/`,
  sitemap: `${baseUri}/sitemap`,
  browse: `${baseUri}/suppliers`,
  enquiryForm: `${baseUri}/enquiry`,
  signup: `${baseUri}/signup`,
  login:
    process.env.NODE_ENV !== 'development'
      ? `${baseUri}/login`
      : `${baseUri}/mock-login`,
  resetPassword: `${baseUri}/reset-password`,
  resetEnquiryPasswordSuccess: `${baseUri}/reset-enquiry-password-success`,
  landing: (category = '[category]', id = '[id]') =>
    `${baseUri}/${category}/${id}`,
  info: (id = '[id]') => `${baseUri}/about/${id}`,
  dashboard: `${baseUri}/dashboard`,
  supplier: (path = '') => `${baseUri}${SUPPLIERS_DASHBOARD}/${path}`,
  publicEvents: `${baseUri}${SUPPLIERS_DASHBOARD}/public-events`,
  favourites: `${baseUri}/my-favourites`,
  settings: `${baseUri}/settings`,
  payments: `${baseUri}/my-payments`,
  bookings: `${baseUri}/my-bookings`,
  blogPost: (id = '[uid]') => `${baseUri}/${BLOG}/${id}`,
  blogCategory: (id = '[category]') => `${baseUri}/${BLOG}/category/${id}`,
  messages: `${baseUri}/messages`,
  supplierProfile: (slug = '[slug]') => `${baseUri}/suppliers/${slug}`,
  customerEvent: eventId => `${baseUri}/dashboard/${eventId}`,
  customerEventRequest: (eventId, requestId) =>
    `${baseUri}/dashboard/${eventId}/${requestId}`,
  customerQuote: (eventId, requestId, quoteId) =>
    `${baseUri}/dashboard/${eventId}/${requestId}/${quoteId}`,
  partnerTerms: `${baseUri}/partner-terms`,
  privacy: `${baseUri}/privacy`,
  listing: pages =>
    `${baseUri}${basePath}${pages.map(page => `/${page}`).join('')}`,
  noPrefixListing: pages =>
    `${basePath}${pages.map(page => `/${page}`).join('')}`,
  blog: createRootPath('blog'),
  locations: createRootPath('locations'),
  corporate: createRootPath('corporate'),
  venues: createRootPath('venues'),
  drinks: createRootPath('drinks'),
  event: createRootPath('event'),
  food: createRootPath('food'),
  events: createRootPath('events'),
  christmas: createRootPath('christmas'),
  photography: createRootPath('photography'),
  weddings: createRootPath('weddings'),
  listings: createRootPath('listings'),
  about: createRootPath('about'),
  live: createRootPath('live'),
  partners: createRootPath('partners'),
  terms: `${baseUri}/terms`,
  contact: createRootPath('contact'),
  errorPage: `${baseUri}/404`,
  conversation: conversationUuid => `${baseUri}/messages/${conversationUuid}`,
  carbonOffsetForm: `${baseUri}/offset`,
  infoPages: {
    about: `${baseUri}/about/about-us`,
    whyTogather: `${baseUri}/about/why-togather`,
    becomePartner: `${baseUri}/partners/become-a-partner`,
    becomeVenuePartner: `${baseUri}/partners/become-a-venue`,
    pickingOurSuppliers: `${baseUri}/about/picking-our-suppliers`,
    howWeWork: `${baseUri}/about/how-we-work`,
    safetySecurity: `${baseUri}/about/safety-security`,
    careers: 'https://togather.workable.com/',
  },
  feedback: 'https://portal.prodpad.com/bf8f0350-1e4f-11e9-8b8d-0288f735e5b9',
  faqs: 'https://togather.freshdesk.com/support/home',
};
